/**
 * Binary scopes
 */
export enum Scopes {
  Previews = 'previews',
  Thumbnails = 'thumbnails',
  Originals = 'originals',
}
